import { createSelector } from './selectorWrapper'
import * as WpsRuntime from 'DVWebNodeWpsRuntime'
import { pageSelectors, simpleSelectors } from './basicState'
import { RequestContext } from '@utils'


export const crowBannerSelector = createSelector(
  [
    simpleSelectors.context,
    pageSelectors.crowBanner
  ],
  (
    requestContext: RequestContext,
    banner?: WpsRuntime.atv.wps.BannerModelProps) =>
    banner && {
      title: banner.title,
      body: banner.body,
      csrfToken: banner.csrfToken,
      context: requestContext
    } || undefined
)
